<template>
  <div :class="{component: true, disabled: loading, 'component--box': true}">
    <div class="component__inner">
      <Loading :show="loading" />
      <!--<div>
        <label>Nuvarande lösenord</label>
        <input placeholder="Nuvarande lösenord" v-model="user.current_password" />
      </div>-->
      <div>
        <label>Nytt lösenord</label>
        <input placeholder="Nytt lösenord" type="password" v-model="user.new_password" />
      </div>
      <div>
        <label>Repetera lösenord</label>
        <input placeholder="Repetera lösenord" type="password" v-model="user.new_password_confirm" />
      </div>
      <div class="center wide">
        <p class="error-message" v-if="errorMessage">{{errorMessage}}</p>
      </div>
      <div class="center wide">
        <button class="button--rounded" @click="save()">Spara</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  data() {
    return {
      user: {
        current_password: '',
        new_password: '',
        new_password_confirm: '',
      },
      loading: false,
      errorMessage: '',
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    async save() {
      this.loading = true;
      const { success, errorMessage } = await API.post('/account/update-password', this.user);
      if (!success) {
        this.errorMessage = errorMessage;
      } else {
        this.errorMessage = '';
        this.new_password = '';
        this.new_password_confirm = '';

        this.openModal(['GeneralModal', {
          title: 'Sparat',
          content: 'Ditt nya lösenord har sparats.',
        }]);
      }

      this.loading = false;
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
@import '~@/global-v2.styl'

.component
  background-color white
  padding: 2rem
  padding-top 3rem
  width: 100%
  display: block

  .component__inner
    max-width 539px
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content space-between
    & > div
      width 100%
      margin-bottom: 1.5rem
    label
      v2-label()

.disabled
  disabled-grey()

input[type="password"]
  v2-input()

.error-message
  margin-top 10px
  margin-bottom 10px
</style>



// WEBPACK FOOTER //
// MyPagePassword.vue?4d9ffb50